const DEFAULT_API_URL = import.meta.env.PROD
  ? 'https://jobs-opportunity-backend.vercel.app'
  : 'http://localhost:3005';

const API_ROOT = (import.meta.env.VITE_API_URL || DEFAULT_API_URL).replace(/\/$/, '');
export const API_BASE_URL = `${API_ROOT}/api/v1`;

export const endpoints = {
  jobs: {
    list: `${API_BASE_URL}/jobs`,
    search: `${API_BASE_URL}/jobs/search`,
  },
  blogs: {
    list: `${API_BASE_URL}/blogs`,
    search: `${API_BASE_URL}/blogs/search`,
    detail: (id) => `${API_BASE_URL}/blogs/${id}`,
    byCategory: (category) => `${API_BASE_URL}/blogs/category/${category}`
  },
  jobAlerts: {
    subscribe: `${API_BASE_URL}/users/subscribe`
  },
  // New SEO endpoints
  seo: {
    job: (slug) => `${API_BASE_URL}/seo/job/${slug}`,
    blog: (slug) => `${API_BASE_URL}/seo/blog/${slug}`,
    page: (page) => `${API_BASE_URL}/seo/page/${page}`
  }
}; 